export default {
  Control: "control",
  Variation1: "variation1",
  Variation2: "variation2",
  Variation3: "variation3",
  Variation4: "variation4",
  Variation5: "variation5",
};
